export default "__VITE_ASSET__C$_GK3DH__"